import React from 'react';
import PropTypes from 'prop-types';
import urlParse from 'url-parse';
import SocialAuthEmailPopup from './SocialAuthEmailPopup.jsx';
import _ from 'lodash';

export class FacebookAuthButton extends React.Component {
  constructor() {
    super();

    this.code = null;
  }

  render() {
    const {isNoEmailProvidedError} = this.props;
    return (
      <span>
        {
          isNoEmailProvidedError ?
            <SocialAuthEmailPopup onSendAuthEmail={this.sendEmail.bind(this)}/> : null
        }
        <button className="ba-login-social-button facebook"
                type="button"
                onClick={this.onFacebookLogin.bind(this)}>
          <span className="fa fa-facebook-square"
                          title="Log in with Facebook"
                          aria-hidden="true" />
        </button>
      </span>
    );
  }

  onFacebookLogin() {
    this.openFbAuthPopup();
  }

  openFbAuthPopup() {
    const {fbAppId, onSendAuthRequest} = this.props;
    const redirectUri = getRedirectUrl();
    const url = `https://www.facebook.com/dialog/oauth?client_id=${fbAppId}&redirect_uri=${redirectUri}&display=popup&scope=email`;
    this.popup = openSocialLoginPopup(url);

    this.listenForFbCredentials(this.popup).then((query) => {
      this.code = query.code;
      onSendAuthRequest('facebook', this.code, redirectUri);
    });
  }

  listenForFbCredentials(popup, resolve, reject) {
    if (!resolve) {
      return new Promise((resolve, reject) => {
        this.listenForFbCredentials(popup, resolve, reject);
      });
    }

      let query = null;
      try {
        query = urlParse(popup.location, true).query;
      } catch (error) {
        // Ignore Exception: Blocked a frame with origin from accessing a cross-origin frame.
        // A hack to get around same-origin security policy errors
      }
      if (query && query.code) {
        popup.close();
        resolve(query);
      } else if (popup.closed) {
        reject({errors: 'Authentication was cancelled.'});
      } else {
        setTimeout(() => {
          this.listenForFbCredentials(popup, resolve, reject);
        }, 500);
      }
  }

  sendEmail(email) {
    this.props.onSendAuthRequest('facebook', this.code, getRedirectUrl(), email);
  }
}

FacebookAuthButton.propTypes = {
  fbAppId: PropTypes.string.isRequired,
  onSendAuthRequest: PropTypes.func.isRequired,
  isNoEmailProvidedError: PropTypes.bool
};

export class TwitterAuthButton extends React.Component {
  constructor() {
    super();

    this.oauthToken = null;
    this.oauthVerifier = null;
  }

  componentWillReceiveProps(nextProps) {
    const hasReceivedOAuth1Token = nextProps.oauthToken && this.props.oauthToken !== nextProps.oauthToken;
    if (hasReceivedOAuth1Token) {
      this.openTwitterAuthPopup(nextProps.oauthToken);
    }
  }

  render() {
    const {isNoEmailProvidedError} = this.props;
    return (
      <span>
        {
          isNoEmailProvidedError ?
            <SocialAuthEmailPopup onSendAuthEmail={this.sendEmail.bind(this)}/> : null
        }
        <button className="ba-login-social-button twitter"
                type="button"
                onClick={this.onTwitterLogin.bind(this)}>
          <span className="fa fa-twitter-square"
                            title="Log in with Twitter"
                            aria-hidden="true" />
        </button>
      </span>
    );
  }

  onTwitterLogin() {
    const redirectUri = getRedirectUrl();
    this.props.onRetrieveAuthRequestToken('twitter', redirectUri);
  }

  openTwitterAuthPopup(oauthRequestToken) {
    const url = `https://api.twitter.com/oauth/authenticate?oauth_token=${oauthRequestToken}`;
    this.popup = openSocialLoginPopup(url);

    this.listenForTwitterCredentials(this.popup).then((query) => {
      const payload = {
        oauthToken: query.oauth_token,
        oauthTokenSecret: this.props.oauthTokenSecret,
        oauthVerifier: query.oauth_verifier,
        provider: 'twitter'
      };

      this.oauthToken = payload.oauthToken;
      this.oauthVerifier = payload.oauthVerifier;

      this.props.onSendAuthRequest(payload);
    });
  }

  listenForTwitterCredentials(popup, resolve, reject) {
    if (!resolve) {
      return new Promise((resolve, reject) => {
        this.listenForTwitterCredentials(popup, resolve, reject);
      });
    }

      let query = null;
      try {
        query = urlParse(popup.location, true).query;
      } catch (error) {
        // Ignore Exception: Blocked a frame with origin from accessing a cross-origin frame.
        // A hack to get around same-origin security policy errors
      }
      if (query && query.oauth_token && query.oauth_verifier) {
        popup.close();
        resolve(query);
      } else if (popup.closed) {
        reject({errors: 'Authentication was cancelled.'});
      } else {
        setTimeout(() => {
          this.listenForTwitterCredentials(popup, resolve, reject);
        }, 500);
      }
  }

  sendEmail(email) {
    const payload = {
      oauthToken: this.oauthToken,
      oauthTokenSecret: this.props.oauthTokenSecret,
      oauthVerifier: this.oauthVerifier,
      provider: 'twitter',
      email
    };
    this.props.onSendAuthRequest(payload);
  }
}

TwitterAuthButton.propTypes = {
  onRetrieveAuthRequestToken: PropTypes.func.isRequired,
  oauthToken: PropTypes.string,
  oauthTokenSecret: PropTypes.string,
  onSendAuthRequest: PropTypes.func.isRequired,
  isNoEmailProvidedError: PropTypes.bool
};

export class GoogleplusAuthButton extends React.Component {
  constructor() {
    super();

    this.code = null;
  }

  render() {
    const {isNoEmailProvidedError} = this.props;
    return (
      <span>
        {
          isNoEmailProvidedError ?
            <SocialAuthEmailPopup onSendAuthEmail={this.sendEmail.bind(this)}/> : null
        }
        <button className="ba-login-social-button google"
                type="button"
                onClick={this.onGoogleplusLogin.bind(this)}>
          <span className="fa fa-google-plus-square"
                          title="Log in with Google+"
                          aria-hidden="true" />
        </button>
      </span>
    );
  }

  onGoogleplusLogin() {
    alert('connect Googleplus to app');
  }

  sendEmail() {
    alert('connect Googleplus to app');
  }
}

GoogleplusAuthButton.propTypes = {
  isNoEmailProvidedError: PropTypes.bool
};

export class LinkedinAuthButton extends React.Component {
  constructor() {
    super();

    this.code = null;
  }

  render() {
    const {isNoEmailProvidedError} = this.props;
    return (
      <span>
        {
          isNoEmailProvidedError ?
            <SocialAuthEmailPopup onSendAuthEmail={this.sendEmail.bind(this)}/> : null
        }
        <button className="ba-login-social-button linkedin"
                type="button"
                onClick={this.onLinkedinLogin.bind(this)}>
          <span className="fa fa-linkedin-square"
                          title="Log in with Linkedin"
                          aria-hidden="true" />
        </button>
      </span>
    );
  }

  onLinkedinLogin() {
    alert('connect Linkedin to app');
  }

  sendEmail() {
    alert('connect Linkedin to app');
  }
}

LinkedinAuthButton.propTypes = {
  isNoEmailProvidedError: PropTypes.bool
};


function openSocialLoginPopup(url) {
  const popup = window.open(url, 'sharewin', 'left=20,top=20,width=500,height=400,toolbar=1,resizable=0');
  if (popup && popup.focus) {
    popup.focus();
  }
  return popup;
}

function getRedirectUrl() {
  const url = urlParse(_.get(document, 'location.href'), false);
  url.set('query', null);
  return url.toString();
}



// WEBPACK FOOTER //
// ./shared/auth/SocialAuthButtons.jsx